/* GoalTypesAnnouncementBanner.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz115i%7Bcolor%3Avar(--ds-background-accent-blue-subtle%2C%23669df1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._i0dl1wug%7Bflex-basis%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zkb7n%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx2vrvc%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1aqn%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulpu2gc%7Bgap%3Avar(--ds-space-100%2C8px)%7D");
import React from 'react';
import Banner from '@atlaskit/banner';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import InformationIcon from '@atlaskit/icon/core/status-information';
import Link from '@atlaskit/link';
import { Box } from '@atlaskit/primitives/compiled';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { GoalsAppChangeboardingExperience } from '@townsquare/post-office/placements';
import { fg } from '@townsquare/stat-sig/gate';
const messages = defineMessages({
  dismissLabel: {
    id: 'townsquare.site-banner.goal-types-announcement-banner.dismiss',
    description: 'Accessibility label for dismiss on goal types announcement banner',
    defaultMessage: 'Dismiss announcement'
  },
  body: {
    id: 'townsquare.site-banner.goal-types-announcement-banner.content',
    description: 'Announcement about creating FY27 OKRs using new Objective and Key result goal types, with a link to more information',
    defaultMessage: 'FY27 OKRs just got an upgrade. Create your FY27 OKRs using the new Objective and Key result goal types. More info at <link>go/goaltypes</link>'
  }
});
const styles = {
  bannerRow: "_zulpu2gc _4cvr1h6o _bfhk1aqn _1e0c1txw _2lx2vrvc _1bsb1osq",
  bannerGrow: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
  link: "_syaz115i"
};

/*
	Temporary banner for Goal Types announcement (FY27 OKR Refresh).
*/
export const GoalTypesAnnouncementBanner = (): React.JSX.Element | null => {
  const intl = useIntl();
  const shouldDisplayGoalTypesAnnouncementBanner = fg('new-okr-goals-banner');
  if (!shouldDisplayGoalTypesAnnouncementBanner) {
    return null;
  }
  return <GoalsAppChangeboardingExperience featureId="goal-types-announcement-banner">
			{({
      onDismiss
    }: {
      onDismiss: () => void;
    }) => <Box xcss={styles.bannerRow}>
					<Box xcss={styles.bannerGrow}>
						<Banner appearance="announcement" icon={<InformationIcon color="currentColor" label="" size="small" />} testId="goal-types-announcement-banner">
							<FormattedMessage {...messages.body} values={{
            link: chunks => <Link href="https://go.atlassian.com/goaltypes" target="_blank">
											<Box as="span" xcss={styles.link}>
												{chunks}
											</Box>
										</Link>
          }} />
						</Banner>
					</Box>
					<IconButton appearance="subtle" icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-inverse, #FFFFFF)"} label="" />} label={intl.formatMessage(messages.dismissLabel)} onClick={onDismiss} testId="goal-types-announcement-banner-dismiss" />
				</Box>}
		</GoalsAppChangeboardingExperience>;
};